// What the load report's h2 / enc / via say (LOAD-H2-CACHE). The page cannot
// see the wire once the service worker (client/sw.js) answers: the navigation
// entry has nextHopProtocol '' and every entry encodedBodySize === decodedBodySize
// (the worker hands the page a decoded body), so a navigation-only reader
// reports h2:false / enc:false for a server that speaks h2 + br. Read it per
// RESPONSE instead:
//  - net   = answered from the network: a page-direct entry with transferSize > 0, plus every
//            worker fetch whose own timing entry had transferSize > 0 (the worker posts
//            {vrmWire: [url, bytes, protocol, encoded]}; assetq.js onWire reads [0..1] only);
//  - sw    = answered by the worker from its own cache or the HTTP cache behind it;
//  - cache = a page-direct entry the HTTP cache answered (transferSize 0).
// h2 = some NETWORK response went over h2; enc = some NETWORK response was
// content-encoded (br / gzip). A visit that fetched nothing reports false/false
// with via.net 0: read it with `via`, never alone.
const _seen = { net: 0, h2: false, enc: false };

export function onNetSeen(data) {
  const w = data && data.vrmWire;
  if (!Array.isArray(w) || !(w[1] > 0)) return;            // a cache answer: no wire, no protocol
  _seen.net++;
  if (w[2] === 'h2') _seen.h2 = true;
  if (w[3] === true) _seen.enc = true;
}

if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
  try { navigator.serviceWorker.addEventListener('message', (ev) => onNetSeen(ev.data)); } catch { /* no worker */ }
}

// → { h2, enc, via: {net, sw, cache} } over resource-timing `entries`; `enc0` =
// the caller's own page-direct encoded flag
export function netSeen(entries, nav, enc0 = false) {
  let net = 0, sw = 0, cache = 0, h2 = _seen.h2, enc = enc0 || _seen.enc;
  for (const e of entries) {
    if (!e.nextHopProtocol && e.workerStart > 0) { sw++; continue; }     // the worker answered
    if (e.transferSize > 0) {
      net++;
      if (e.nextHopProtocol === 'h2') h2 = true;
      if (e.encodedBodySize > 0 && e.encodedBodySize < e.decodedBodySize) enc = true;
    } else cache++;
  }
  // the worker's network answers are among the `sw` entries
  const swNet = Math.min(_seen.net, sw);
  if (nav && !nav.workerStart && nav.nextHopProtocol === 'h2') h2 = true;
  return { h2, enc, via: { net: net + swNet, sw: sw - swNet, cache } };
}
